export default "__VITE_PUBLIC_ASSET__d6d9f0e1__"